import React from 'react';
import { BRAND_PRIMARY } from "../theme/brandTheme.js";

/**
 * A vertical zoom slider for the map controls.
 *
 * Mantine's <Slider> is horizontal-only (no orientation/vertical support), so
 * this uses a native <input type="range"> turned vertical via CSS writing-mode.
 * Unlike a CSS-rotated Mantine slider, this stays fully draggable and
 * keyboard-accessible, and it's brand-colored via accent-color.
 *
 * Mirrors the Mantine Slider API used at the call sites:
 *   value, min, max, step, onChange(value), onChangeEnd(value)
 */
export function VerticalZoomSlider({ value, min, max, step = 1, height = 150, onChange, onChangeEnd }) {
  const commit = (e) => { if (onChangeEnd) onChangeEnd(Number(e.currentTarget.value)); };
  return (
    <input
      type="range"
      min={min}
      max={max}
      step={step}
      value={value}
      onChange={(e) => { if (onChange) onChange(Number(e.currentTarget.value)); }}
      onMouseUp={commit}
      onTouchEnd={commit}
      onKeyUp={commit}
      style={{
        writingMode: 'vertical-lr',
        direction: 'rtl', // min at bottom, max at top (up = zoom in)
        width: 20,
        height,
        accentColor: BRAND_PRIMARY,
        cursor: 'pointer',
        margin: '6px 0',
        padding: 0,
      }}
    />
  );
}

export default VerticalZoomSlider;
